<template>
    <div class="mk-organisationform row">
        <div class="pl-0 col-12">
            <div
                class="col-12 hf-base-card hf-organisation-card-padding admin-input-wrap"
            >
                <v-row>
                    <v-col cols="4">
                        <label>Name</label>
                        <v-text-field
                            outlined
                            v-model="organisation.name"
                            placeholder=""
                            class="text-field"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <label>From (Place of Birth)</label>
                        <v-text-field
                            outlined
                            v-model="organisation.name"
                            placeholder=""
                            class="text-field"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <label>Bio</label>
                        <v-text-field
                            outlined
                            v-model="organisation.abn"
                            placeholder=""
                            class="text-field"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <label>Description</label>
                        <v-text-field
                            outlined
                            v-model="organisation.email"
                            placeholder=""
                            class="text-field"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import Artist from "../../models/Artist";

export default {
    props: {
        initial_artist: {
            type: Object,
        },
    },
    async mounted() {
        this.getOrganisation();
    },
    data() {
        return {
            organisation: new Organisation(this.initial_organisation),
        };
    },
    methods: {
        async getOrganisation() {
            if (this.initial_organisation) {
                this.organisation = await Organisation.find(
                    this.initial_organisation.id
                );
            }
        },
        async handleSubmit() {
            this.organisation.save().then((response) => {
                if (response.id) {
                    if (!this.initial_organisation) {
                        window.location.href =
                            "/admin/organisations/" + response.id + "/edit";
                    }
                }
            });
        },
    },
};
</script>
